// Función para obtener los datos del archivo JSON en GitHub
async function fetchProductDataFromGitHub() {
    try {
        const response = await fetch('https://raw.githubusercontent.com/fposteraro/test/main/products-search-tag.json');
        if (!response.ok) {
            throw new Error('No se pudo obtener la respuesta del servidor.');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error al obtener los datos del archivo JSON:', error);
        return null;
    }
}

// Función para procesar los datos y llenar los select boxes
function processProductData(data) {
    console.log("Datos recibidos del archivo JSON:", data);

    if (!data) {
        console.error('No se pudo obtener el archivo JSON o no hay datos.');
        return;
    }

    // Obtener select boxes del formulario
    const countrySelect = document.getElementById('country-select');
    const regionSelect = document.getElementById('region-select');
    const typeSelect = document.getElementById('type-select');

    // Verificar que los select boxes existan
    if (!countrySelect || !regionSelect || !typeSelect) {
        console.warn('Uno o más select boxes no están presentes en el DOM.');
        return;
    }

    // Variables para almacenar opciones únicas
    const countries = new Set();
    const regions = new Set();
    const types = new Set();

    // Recorrer los datos para extraer las opciones únicas
    data.forEach(item => {
        if (item.Country) countries.add(item.Country.trim());
        if (item.Region) regions.add(item.Region.trim());
        if (item.Type) types.add(item.Type.trim());
    });

    // Convertir Sets a arrays y ordenar alfabéticamente
    const sortedCountries = Array.from(countries).sort();
    const sortedRegions = Array.from(regions).sort();
    const sortedTypes = Array.from(types).sort();

    // Añadir opción "Others" solo en el select de Countries
    if (!sortedCountries.includes("Others")) sortedCountries.push("Others");

    // Llenar select boxes con las opciones procesadas
    addOptionsToSelectBox(countrySelect, sortedCountries, "Country");
    addOptionsToSelectBox(regionSelect, sortedRegions, "Region");
    addOptionsToSelectBox(typeSelect, sortedTypes, "Type");

    // Escuchar cambios en el select box de países para actualizar el de regiones y tipos
    countrySelect.addEventListener('change', function() {
        const selectedCountry = this.value;

        // Limpiar los selectores de regiones y tipos
        regionSelect.innerHTML = '<option value="" disabled selected hidden>Region</option>';
        typeSelect.innerHTML = '<option value="">Type</option>';

        if (selectedCountry === "Others") {
            addOptionsToSelectBox(regionSelect, ["Other"], "Region");
            addOptionsToSelectBox(typeSelect, ["Others"], "Type");
            return;
        }

        // Filtrar los datos según el país seleccionado
        const filteredData = data.filter(item => item.Country.trim() === selectedCountry);

        // Variables para almacenar opciones filtradas
        const filteredRegions = new Set();
        const filteredTypes = new Set();

        // Recorrer los datos filtrados para extraer las opciones únicas
        filteredData.forEach(item => {
            if (item.Region) filteredRegions.add(item.Region.trim());
            if (item.Type) filteredTypes.add(item.Type.trim());
        });

        // Convertir Set a array y ordenar alfabéticamente
        const sortedFilteredRegions = Array.from(filteredRegions).sort();
        const sortedFilteredTypes = Array.from(filteredTypes).sort();

        // Llenar select boxes de regiones y tipos filtrados
        addOptionsToSelectBox(regionSelect, sortedFilteredRegions, "Region");
        addOptionsToSelectBox(typeSelect, sortedFilteredTypes, "Type");
    });

    // Disparar evento 'change' en el select box de países para llenar inicialmente el de regiones y tipos
    countrySelect.dispatchEvent(new Event('change'));

    // Asignar eventos a los select boxes para detectar "Others"
    [countrySelect, regionSelect, typeSelect].forEach(select => {
        select.addEventListener('change', () => checkForOthers(countrySelect, regionSelect, typeSelect));
    });
}

// Función para agregar opciones a un select box
function addOptionsToSelectBox(selectBox, options, defaultText) {
    if (!selectBox) {
        console.warn(`El select box no existe: ${defaultText}`);
        return;
    }

    // Limpiar opciones actuales y establecer el texto predeterminado
    selectBox.innerHTML = `<option value="" disabled selected hidden>${defaultText}</option>`;

    // Agregar opciones al select box
    options.forEach(option => {
        let opt = document.createElement('option');
        opt.value = option;
        opt.innerHTML = option;
        selectBox.appendChild(opt);
    });
}

// Función para verificar si "Others" ha sido seleccionado y bloquear otros inputs
function checkForOthers(countrySelect, regionSelect, typeSelect) {
    if (!countrySelect || !regionSelect || !typeSelect) return;

    const isOthersSelected = countrySelect.value === "Others";

    if (isOthersSelected) {
        // Deshabilitar todos los selectores excepto el de Country
        [regionSelect, typeSelect].forEach(select => select.disabled = true);
    } else {
        // Habilitar todos los selectores si "Others" no está seleccionado
        [regionSelect, typeSelect].forEach(select => select.disabled = false);
    }
}

// Evento al cargar la página
document.addEventListener("DOMContentLoaded", async function() {
    console.log("Cargando la página...");
    // Obtener datos del archivo JSON en GitHub
    const productData = await fetchProductDataFromGitHub();

    if (!productData) {
        console.error("No se pudo cargar el JSON.");
        return;
    }

    console.log("Datos del archivo JSON:", productData);

    // Procesar y llenar los select boxes con los datos obtenidos
    processProductData(productData);

    // Evento al enviar el formulario de búsqueda
    const searchForm = document.getElementById('search-form');
    if (searchForm) {
        searchForm.onsubmit = function(event) {
            event.preventDefault();

            // Obtener valores seleccionados en los select boxes
            var country = document.getElementById('country-select').value;
            var region = document.getElementById('region-select').value;
            var type = document.getElementById('type-select').value;

            // Verificar si se ha seleccionado "Others"
            if (country === "Others") {
                // Redirigir solo a la página de resultados sin parámetros adicionales
                window.location.href = `/pages/search-results-page`;
            } else {
                // Construir la URL de búsqueda según los valores seleccionados
                var queryParams = new URLSearchParams();
                if (country) queryParams.append('rb_snize_facet10', country);
                if (type) queryParams.append('rb_snize_facet9', type);
                if (region) queryParams.append('rb_snize_facet3', region);

                // Redireccionar a la página de resultados de búsqueda con los parámetros
                window.location.href = `/pages/search-results-page?${queryParams.toString()}`;
            }
        };
    }
});
